<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Usrermanuals page
@Last modified by:   tom
@Last modified time: 2019-06-12T17:59:38+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <c-page id="usermanuals"
        :title="$t('resources.docs.title')"
        :jbheader="$t('resources.docs.subtitle')"
        :jblead="$t('resources.docs.lead')"
        jbvariant="dark"
        :sideimage="assetUrl('img/resources/confused.jpg')">

    <!-- The team -->
    <br>

    <b-row>
      <b-col
        v-for="f in 2"
        :key="f"
        md="4">

        <b-card
          no-body
          class="mb-4"
          style="min-width: 10rem;" >

          <b-card-header>
            <h6 v-html="$t(`resources.docs.${f}.title`)" />
          </b-card-header>

          <b-card-body>
            <a :href="fileName(f)">
              <lzimg
                :src="assetUrl('img/resources/' + $t(`resources.docs.${f}.img`))"
                height="300"
                width="600"
                fluid/>
            </a>
            <p class="card-text mt-4" v-html="$t(`resources.docs.${f}.slot`)"/>

          </b-card-body>

          <b-card-footer>
            <!-- download button loop, in all available languages -->
            <span
              v-for="filelang in languages"
              :key="filelang">
              <b-button
                v-if="$te(`resources.docs.${f}.files.${filelang}`,'en')"
                :href="folder + $t(`resources.docs.${f}.files.${filelang}`)"
                target="_blank"
                size="sm"
                variant="secondary"
                class="mb-2 mr-1"
                style="min-width: 9rem;">
                {{ $t(`def.download`) }} ({{ filelang }})
                <icon :name="$t(`resources.docs.${f}._type`) | iconName" class="ml-1 text-white" scale="1.5"/>
              </b-button>
            </span>
          </b-card-footer>

        </b-card>
      </b-col>
    </b-row>

  </c-page>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'DownloadDocs',
  filters: {
    // icon file types: image, pdf, video, word, excel, see lib/_icons-loader.js
    iconName: (filetype) => {
      if (!filetype) return 'file'
      return `file-${filetype}`
    }
  },
  data: () => {
    return {
      actLocale: Vue.config.lang,
      folder: '/downloads/resources/',
      languages: ['en', 'nl', 'de', 'fr', 'es', 'ru']
    }
  },
  methods: {
    // return the filename for this locale, and if not found return the English file
    fileName: function (f) {
      const fileLocale = this.$i18n.te(`resources.docs.${f}.files.${this.actLocale}`, 'en') ? this.actLocale : 'en'
      const fileName = this.$i18n.t(`resources.docs.${f}.files.${fileLocale}`)
      return this.folder + fileName
    }
  }
}
</script>

<style lang="scss" scoped>

  #usermanuals .card-body,
  #usermanuals .card-header,
  #usermanuals .card-footer
  {
    padding: 0.5em;
  }

</style>
